import React, {useState, useEffect} from "react"
import {useDispatch, useSelector} from "react-redux"

import helpers from "../../lib/helpers"

/**
 * Logo component get logo image for each Customer from their Firebase
 * @component
 * @example
 * return <Logo/>
 *
 */

const Logo = () => {
  const dispatch = useDispatch()

  const fbdata = useSelector(state => state.fbdata)

  const [src, setSrc] = useState("")

  useEffect(() => {
    if (fbdata && fbdata.logoUrl) {
      helpers.getDirectLink(fbdata.logoUrl, url => {
        setSrc(url)
      })
    } else {
      setSrc("/assets/img/logo.png")
    }
  }, [dispatch, fbdata])

  return <img src={src} alt="logo" title="logo" />
}

export default Logo
